// Converts a number into Indian-format words (Crore / Lakh / Thousand).
export function numberToWordsINR(value) {
    let num = Math.round(Number(value) || 0);
    if (num === 0) return "Zero Only";

    const a = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
        "Seventeen", "Eighteen", "Nineteen",
    ];
    const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

    function two(n) {
        if (n < 20) return a[n];
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    }

    function three(n) {
        const h = Math.floor(n / 100);
        const r = n % 100;
        return (h ? a[h] + " Hundred" + (r ? " " : "") : "") + (r ? two(r) : "");
    }

    let words = "";
    const crore = Math.floor(num / 10000000);
    num %= 10000000;
    const lakh = Math.floor(num / 100000);
    num %= 100000;
    const thousand = Math.floor(num / 1000);
    num %= 1000;
    const hundred = num;

    if (crore) words += three(crore) + " Crore ";
    if (lakh) words += two(lakh) + " Lakh ";
    if (thousand) words += two(thousand) + " Thousand ";
    if (hundred) words += three(hundred) + " ";

    return words.trim().replace(/\s+/g, " ") + " Only";
}
